'use es6';

import { EXTRACT_SUB_PROPERTY } from 'feedback-schema/constants/tokens';
export const hasSubProperty = (property = '') => new RegExp(EXTRACT_SUB_PROPERTY).test(property);
export const getPrimaryPropertyName = (property = '') => property.split('.')[0] || '';
export const getSubPropertyName = (property = '') => property.split('.')[1] || '';